'use client';

import { MONO_FONT } from '@/theme';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from 'next/link';

export default function ArticleCard({
  category,
  title,
  excerpt,
  author,
  date,
  readTime,
  href = '#',
  featured = false,
  imageBg = 'grey.100',
}) {
  return (
    <Box
      component={Link}
      href={href}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid',
        borderColor: 'grey.200',
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': {
          borderColor: 'primary.main',
        },
        transition: 'border-color 0.15s ease',
      }}
    >
      <Box
        sx={{
          bgcolor: imageBg,
          aspectRatio: featured ? '16/7' : '16/9',
          flexShrink: 0,
        }}
      />

      <Box sx={{ p: { xs: '20px', md: featured ? '32px' : '24px' }, flex: 1, display: 'flex', flexDirection: 'column' }}>
        {category && (
          <Box
            sx={{
              fontFamily: MONO_FONT,
              fontSize: '10px',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: 'text.accent',
              mb: 1.5,
            }}
          >
            {category}
          </Box>
        )}

        <Typography
          variant={featured ? 'h3' : 'h4'}
          sx={{
            fontSize: featured
              ? 'clamp(22px, 2vw, 30px)'
              : 'clamp(17px, 1.3vw, 20px)',
            fontWeight: 500,
            letterSpacing: '-0.015em',
            lineHeight: 1.25,
            color: 'text.primary',
            mb: 1.5,
          }}
        >
          {title}
        </Typography>

        {excerpt && (
          <Typography
            sx={{
              fontSize: '15px',
              lineHeight: 1.65,
              color: 'grey.600',
              mb: 2,
              flex: 1,
            }}
          >
            {excerpt}
          </Typography>
        )}

        {(author || date || readTime) && (
          <Box
            sx={{
              display: 'flex',
              gap: '16px',
              flexWrap: 'wrap',
              fontFamily: MONO_FONT,
              fontSize: '11px',
              color: 'text.muted',
              mt: 'auto',
              pt: 2,
              borderTop: '1px solid',
              borderColor: 'grey.100',
            }}
          >
            {author && <span>{author}</span>}
            {date && <span>{date}</span>}
            {readTime && <span>{readTime}</span>}
          </Box>
        )}
      </Box>
    </Box>
  );
}
